
import Holidaysdata from "@/data/jsons/Holidays2025.json";
import hrmsdata from '@/data/jsons/GlossaryHRMS.json';
import crmdata from '@/data/jsons/GlossaryCRM.json';
import whatsappdata from '@/data/jsons/GlossaryWhatsapp.json';
import campaigndata from '@/data/jsons/GlossaryCampaign.json';
import pmsdata from '@/data/jsons/GlossaryPMS.json';
import payrolldata from '@/data/jsons/GlossaryPayroll.json';
import GeneralPageSEOMetadata from '@/data/jsons/GeneralPageSEOMetadata.json'
import alternative from '@/data/jsons/AlternativeData.json'
import webstories from '@/data/jsons/WebStoryData.json'

const WebStoriesdata = webstories;

const Alternativedata = alternative;
const GeneralPagesSEOData = GeneralPageSEOMetadata

const GlossaryHRMS = hrmsdata;
const GlossaryCRM = crmdata;
const GlossaryWhatsapp = whatsappdata;
const GlossaryCampaign = campaigndata;
const GlossaryPMS = pmsdata;
const GlossaryPayroll = payrolldata;

const AllGlossaryData = [...GlossaryHRMS, ...GlossaryCRM, ...GlossaryWhatsapp, ...GlossaryCampaign, ...GlossaryPMS, ...GlossaryPayroll];

// Listing page data
const Glossarieslistingdata = {
    'All Glossary': AllGlossaryData,
    HRMS: GlossaryHRMS,
    CRM: GlossaryCRM,
    Whatsapp: GlossaryWhatsapp,
    Campaign: GlossaryCampaign,
    PMS: GlossaryPMS,
    Payroll: GlossaryPayroll,
};

const Holidays2025data = Holidaysdata;

const GujaratHolidaysData = Holidaysdata.find(holiday => holiday.state === "Gujarat");

// Convert date
const shouldShowMonth = (holidayItem: { month: any; }, index: number, holidays: { month: any; }[]) => {
    return index === 0 || holidayItem.month !== holidays[index - 1]?.month;
};

// Fetch State Data From slug For Holidays
const getHolidaysBySlug = (slug: string) => {
    return Holidaysdata.find(holiday => holiday.seo?.slug === slug) || null;
};

export {
    GlossaryHRMS,
     GlossaryCRM,
    GlossaryPMS,
    GlossaryPayroll,
    AllGlossaryData,
    Glossarieslistingdata,
    Holidays2025data,
    GujaratHolidaysData,
    GeneralPagesSEOData,
    Alternativedata,
    WebStoriesdata,
    shouldShowMonth,
    getHolidaysBySlug
}
